import * as React from "react";
import { useFeatureToggles } from "@grandvisionhq/state";
import { getSessionStorageItem } from "@grandvisionhq/utils";
import { useServerStoreDataContext } from "../../context/context/with-server-store-data-context.js";
import { applyBloomreachAppointmentUrlsConfiguration } from "../helpers/hooks/helpers/apply-bloomreach-appointment-urls-configuration.js";
import { formatRouteForAAB } from "../helpers/hooks/helpers/format-route-for-aab.js";
import { urlFromSessionStorageItem } from "../helpers/hooks/helpers/url-from-session-storage-item.js";
import { useBloomreachPageModels } from "./use-bloomreach-page-models.js";
import { useBrPageContext } from "../../context/context/context.js";
import { getBrPageContent } from "../../utils/utils/get-br-page-content.js";
const STORAGE_KEY = "aab_appointmentState";
const useBloomreachAppointmentURLsConfiguration = (appointmentMenuItems) => {
  const page = useBrPageContext();
  const { storeCode, globalStoreId } = useServerStoreDataContext();
  const { isStoreValueInAabButtonDisabled } = useFeatureToggles();
  const [sessionStorageItem, setSessionStorageItem] = React.useState("");
  const appointmentState = getSessionStorageItem(STORAGE_KEY);
  const pageModels = useBloomreachPageModels();
  const appointmentRoute = pageModels?.routes?.["appointment-book"] || "";
  React.useEffect(() => {
    setSessionStorageItem(appointmentState ?? "");
  }, [appointmentState]);
  if (sessionStorageItem) {
    return urlFromSessionStorageItem({ sessionStorageItem, appointmentMenuItems, appointmentRoute });
  }
  const storeIdentifier = globalStoreId || (typeof storeCode === "number" ? String(storeCode) : null);
  if (storeIdentifier && !isStoreValueInAabButtonDisabled) {
    const searchParams = new URLSearchParams({ storeId: storeIdentifier }).toString();
    return formatRouteForAAB({
      appointmentMenuItems,
      appointmentRoute,
      searchParams,
      route: "what"
    });
  }
  const content = getBrPageContent(
    page,
    pageModels?.appointmentURLsConfiguration
  )?.linkItem;
  try {
    return applyBloomreachAppointmentUrlsConfiguration({
      pathname: page?.getUrl() || "",
      appointmentRoute,
      appointmentMenuItems,
      content
    });
  } catch {
    return appointmentMenuItems;
  }
};
export {
  useBloomreachAppointmentURLsConfiguration
};
//# sourceMappingURL=use-bloomreach-appointment-urls-configuration.js.map
